import '@textbox/renderer/screen.css';
import './styles.css';
import { api, ApiError, type User } from './api.ts';
import { el, clear } from './ui.ts';
import { articleEditor, articlesList } from './views/articles.ts';
import { assetEditor, assetsList } from './views/assets.ts';
import { indexPageView } from './views/index-page.ts';
import { loginView } from './views/login.ts';
import { sectionEditor, sectionsList } from './views/sections.ts';
import { usersView } from './views/users.ts';

const app = document.getElementById('app')!;
let me: User | null = null;

const NAV: Array<[string, string, boolean]> = [
  ['#/articles', 'Articles', false],
  ['#/sections', 'Sections', false],
  ['#/index', 'Index page', false],
  ['#/assets', 'Assets', false],
  ['#/users', 'Users', true],
];

function shell(user: User, content: HTMLElement): HTMLElement {
  const current = location.hash.split('/')[1] ?? 'articles';
  return el('div', { class: 'shell' },
    el('header', {},
      el('a', { class: 'brand', href: '#/articles' }, 'TEXTBOX', el('span', {}, 'content')),
      el('nav', {}, NAV.filter(([, , admin]) => !admin || user.role === 'admin').map(([href, label]) => el('a', { href, class: href.includes(`/${current}`) ? 'on' : '' }, label))),
      el('div', { class: 'who' }, `${user.name} (${user.role})`, ' ', el('a', { href: 'https://textbox.online', target: '_blank', rel: 'noopener' }, 'site ↗'), ' ', el('button', { type: 'button', class: 'link', onClick: async () => { await api.logout(); me = null; render(); } }, 'sign out')),
    ),
    el('main', {}, content),
  );
}

async function view(user: User): Promise<HTMLElement> {
  const parts = location.hash.replace(/^#\/?/, '').split('/');
  const [area, id] = [parts[0] || 'articles', parts[1]];
  try {
    switch (area) {
      case 'articles': return id ? await articleEditor(id === 'new' ? null : id) : await articlesList();
      case 'sections': return id ? await sectionEditor(id === 'new' ? null : id) : await sectionsList();
      case 'index': return await indexPageView();
      case 'assets': return id ? await assetEditor(id === 'new' ? null : id) : await assetsList();
      case 'users': return user.role === 'admin' ? await usersView(user) : el('p', {}, 'Admins only.');
      default: return el('p', {}, 'Not found.');
    }
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) { me = null; render(); return el('div'); }
    return el('p', { class: 'error' }, e instanceof Error ? e.message : String(e));
  }
}

async function render(): Promise<void> {
  if (!me) {
    try { me = await api.me(); } catch { me = null; }
  }
  if (!me) {
    clear(app).appendChild(loginView((u) => { me = u; void render(); }));
    return;
  }
  const content = await view(me);
  clear(app).appendChild(shell(me, content));
}

window.addEventListener('hashchange', () => void render());
void render();
